import React, { Component } from "react";

import PropTypes from "prop-types";

import { Grid } from "@mui/material";
import { withStyles } from "@mui/styles";

import Carousel from 'react-bootstrap/Carousel'

import styles from "./styles";
import './styles.css';
import home1 from "../../assets/images/home1.jpg";
import home2 from "../../assets/images/home2.jpg";
import home3 from "../../assets/images/home3.jpg";
import senior from "../../assets/images/wropromo.png";
import project0 from "../../assets/images/home4.jpg";
import project1 from "../../assets/images/mezastarguidebanner.png";
import project2 from "../../assets/images/gaoleguidebanner.png";
import project3 from "../../assets/images/qlassroombanner.png";

// import home4 from "../../assets/images/home4.jpg";
import pokemon1 from "../../assets/images/pokemon1.jpg";
import $ from "jquery";

class Home extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.scroll = this.scroll.bind(this);
    this.state = {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      index: 0,
      direction: null
    }
  }
  carouselInterval = async (index) => {
    if (index <= 1) {
      this.setState({
        index: index + 1
      });
    } else {
      this.setState({
        index: 0
      });
    }

  };

  handleResize = (e) => {
    this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
  }

  scroll() {
    if (window.location.hash === "#aboutme") {
      $("html, body").animate(
        {
          scrollTop: $("#aboutme").offset().top,
        },
        1000
      );
    }
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("load", this.scroll);
    this.interval = setInterval(
      () => this.carouselInterval(this.state.index), 5000
    )
  }

  componentWillUnmount() {
    window.addEventListener("resize", this.handleResize);
    clearInterval(this.interval);
  }

  render() {
    const { classes } = this.props;

    const carouselAddMinus = async (type, index) => {
      if (type === 'button-next') {
        if (index <= 1) {
          this.setState({
            index: index + 1
          });
        } else {
          this.setState({
            index: 0
          });
        }
      } else {
        if (index >= 1) {
          this.setState({
            index: index - 1
          });
        } else {
          this.setState({
            index: 2
          });
        }

      }
    };

    const directionButtons = (direction, currentIndex) => {
      return (
        <span
          aria-hidden="true"
          className={direction === "Next" ? "carousel-control-next-icon" : "carousel-control-prev-icon"}
          onClick={
            () => carouselAddMinus(direction === "Next" ? "button-next" : "button-prev", currentIndex)
          }
        />
      );
    };


    return (
      <div className={classes.root}>
        {(this.state.windowWidth < 960) ?
          <Grid container style={{ height: this.state.windowHeight / 2, backgroundColor: 'black' }}>
            <Grid size={{ xs: 12, md: 7 }} style={{ position: 'relative', display: 'inline-flex' }}>
              <Carousel style={{ height: "100%", width: "100%" }} interval={null} indicators={false} activeIndex={this.state.index} nextIcon={directionButtons("Next", this.state.index)} prevIcon={directionButtons("Previous", this.state.index)}>
                <Carousel.Item style={{ height: "100%", minHeight: "100px", width: "100%" }}>
                  <div
                    className="d-block"
                    style={{
                      minWidth: "100%",
                      height: this.state.windowHeight / 3,
                      minHeight: "100%",
                      backgroundImage: `url(${home1})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      // filter: `blur(5px)`,
                      // -webkit-filter: blur(8px);
                    }}
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <div
                    className="d-block"
                    style={{
                      minWidth: "100%",
                      height: this.state.windowHeight / 3,
                      minHeight: "100%",
                      backgroundImage: `url(${home2})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                    }}
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <div
                    className="d-block"
                    style={{
                      minWidth: "100%",
                      height: this.state.windowHeight / 3,
                      minHeight: "100%",
                      backgroundImage: `url(${pokemon1})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                    }}
                  />
                </Carousel.Item>
              </Carousel>
            </Grid>
            <Grid size={{ xs: 12, md: 5 }}>
              <Carousel style={{ height: "100%", width: "100%", display: 'block' }} activeIndex={this.state.index} controls={false} indicators={false}>
                <Carousel.Item style={{ height: "100%", width: "100%", alignItems: 'center' }}>
                  <div
                    className="d-block"
                    style={{
                      minWidth: "250%",
                      height: this.state.windowHeight / 6,
                      backgroundImage: `url(${home1})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "bottom left",
                      filter: `blur(5px)`,
                    }}
                  />
                  <Carousel.Caption style={{ top: 0, bottom: 0, }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                      <a href="#aboutme">
                        <h1 style={{ width: "200px", textAlign: 'right', color: 'white', textShadow: `1px 1px #000` }}><b>About<br />Kester Teh</b></h1>
                      </a>
                    </div>

                  </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                  <div
                    className="d-block"
                    style={{
                      minWidth: "120%",
                      height: this.state.windowHeight / 6,
                      backgroundImage: `url(${home2})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      filter: `blur(5px)`,
                    }}
                  />
                  <Carousel.Caption style={{ top: 0, bottom: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                      <a href="/senior">
                        <h1 style={{ width: "200px", textAlign: 'right', color: 'white', textShadow: `1px 1px #000` }}><b>World Robot Olympiad</b></h1>
                      </a>
                    </div>

                  </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                  <div
                    className="d-block"
                    style={{
                      minWidth: "200%",
                      height: this.state.windowHeight / 6,
                      backgroundImage: `url(${pokemon1})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "bottom left",
                      filter: `blur(5px)`,
                    }}
                  />
                  <Carousel.Caption style={{ top: 0, bottom: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                      <a href="/pokemon">
                        <h1 style={{ textAlign: 'right', color: 'white', textShadow: `1px 1px #000` }}><b>Pokémon</b></h1>
                      </a>
                    </div>
                  </Carousel.Caption>
                </Carousel.Item>
              </Carousel>
            </Grid>
          </Grid>
          :
          <Grid container style={{ height: this.state.windowHeight / 1.5, backgroundColor: 'black' }}>
            <Grid size={{ xs: 12, md: 5 }}>
              <Carousel style={{ height: "100%", width: "100%", display: 'block' }} activeIndex={this.state.index} controls={false} indicators={false}>
                <Carousel.Item style={{ height: "100%", width: "100%", alignItems: 'center' }}>
                  <div
                    className="d-block"
                    style={{
                      minWidth: "250%",
                      height: (this.state.windowWidth < 960) ? this.state.windowHeight / 3 : this.state.windowHeight / 1.5,
                      backgroundImage: `url(${home1})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "bottom left",
                      filter: `blur(5px)`,
                    }}
                  />
                  <Carousel.Caption style={{ top: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>
                      <a href="#aboutme">
                        <h1 style={{ width: "200px", textAlign: 'left', color: 'white', textShadow: `1px 1px #000` }}><b>About Kester Teh</b></h1>
                      </a>
                    </div>
                  </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                  <div
                    className="d-block"
                    style={{
                      minWidth: "120%",
                      height: (this.state.windowWidth < 960) ? this.state.windowHeight / 3 : this.state.windowHeight / 1.5,
                      backgroundImage: `url(${home2})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      filter: `blur(5px)`,
                    }}
                  />
                  <Carousel.Caption style={{ top: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>

                      <a href="/senior">
                        <h1 style={{ width: "200px", textAlign: 'left', color: 'white', textShadow: `1px 1px #000` }}><b>World Robot Olympiad</b></h1>
                      </a>
                    </div>
                  </Carousel.Caption>
                </Carousel.Item>
                <Carousel.Item>
                  <div
                    className="d-block"
                    style={{
                      minWidth: "200%",
                      height: (this.state.windowWidth < 960) ? this.state.windowHeight / 3 : this.state.windowHeight / 1.5,
                      backgroundImage: `url(${pokemon1})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "bottom center",
                      filter: `blur(5px)`,
                    }}
                  />
                  <Carousel.Caption style={{ top: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end' }}>

                      <a href="/pokemon">
                        <h1 style={{ width: "200px", textAlign: 'left', color: 'white', textShadow: `1px 1px #000` }}><b>Pokémon</b></h1>
                      </a>
                    </div>
                  </Carousel.Caption>
                </Carousel.Item>
              </Carousel>
            </Grid>
            <Grid size={{ xs: 12, md: 7 }} style={{ position: 'relative', display: 'inline-flex' }}>
              <Carousel style={{ height: "100%", width: "100%" }} interval={null} indicators={false} activeIndex={this.state.index} nextIcon={directionButtons("Next", this.state.index)} prevIcon={directionButtons("Previous", this.state.index)}>
                <Carousel.Item style={{ height: "100%", minHeight: "100px", width: "100%" }}>
                  <div
                    className="d-block"
                    style={{
                      minWidth: "100%",
                      height: (this.state.windowWidth < 960) ? this.state.windowHeight / 3 : this.state.windowHeight / 1.5,
                      minHeight: "100%",
                      backgroundImage: `url(${home1})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      // filter: `blur(5px)`,
                      // -webkit-filter: blur(8px);
                    }}
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <div
                    className="d-block"
                    style={{
                      minWidth: "100%",
                      height: (this.state.windowWidth < 960) ? this.state.windowHeight / 3 : this.state.windowHeight / 1.5,
                      minHeight: "100%",
                      backgroundImage: `url(${home2})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                    }}
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <div
                    className="d-block"
                    style={{
                      minWidth: "100%",
                      height: (this.state.windowWidth < 960) ? this.state.windowHeight / 3 : this.state.windowHeight / 1.5,
                      minHeight: "100%",
                      backgroundImage: `url(${pokemon1})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                    }}
                  />
                </Carousel.Item>
              </Carousel>
            </Grid>
          </Grid>
        }
        <Grid id="aboutme" container style={{}}>
          <Grid size={{ xs: 12, md: 7 }} style={{ minHeight: this.state.windowHeight / 2, alignSelf: 'center', display: 'flex', justifyContent: 'center', flexDirection: 'column', }}>
            <Carousel style={{ height: "100%", width: "100%" }} interval={null} indicators={false} controls={false}>
              <Carousel.Item style={{ height: "100%", width: "100%", alignItems: 'center' }}>
                <div
                  className="d-block"
                  style={{
                    minHeight: 500,
                    height: (this.state.windowWidth < 960) ? this.state.windowHeight / 2 : this.state.windowHeight / 2,
                    backgroundImage: `url(${home3})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center left",
                    filter: `blur(10px)`,
                  }}
                />
                <Carousel.Caption style={{ top: 0, bottom: 0 }}>
                  <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                    <h2 style={{ textAlign: "left", alignSelf: 'flex-start', textShadow: `1px 1px #000`, }}><b>&lt;About Me&gt;</b></h2>
                    <h4 style={{ textAlign: "left", textShadow: `1px 1px #000` }}><b>I am a lively undergrad student at NUS who does code projects, music transcriptions and Pokémon in my free time.<br /><br />Welcome to my site!</b> </h4>
                  </div>
                </Carousel.Caption>

              </Carousel.Item>
            </Carousel>

          </Grid>

          <Grid size={{ xs: 12, md: 5 }} style={{ height: "100%", display: 'flex', alignItems: 'center' }}>
            <div
              className="d-block"
              style={{
                minWidth: "100%",
                height: (this.state.windowHeight / 2 < 501) ? 500 : (this.state.windowWidth < 960) ? this.state.windowHeight / 2 : this.state.windowHeight / 2,
                minHeight: "100%",
                backgroundImage: `url(${home3})`,
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
            />
          </Grid>
        </Grid>

        <Grid container style={{ marginBottom: 64 }}>
          <Grid size={{ xs: 12 }} style={{ display: 'flex', flexDirection: 'column' }}>
            <Carousel style={{ height: "100%", width: "100%" }} interval={null} indicators={false} controls={false}>
              <Carousel.Item style={{ height: "100%", minHeight: "100px", width: "100%" }}>
                <div
                  className="d-block"
                  style={{
                    minWidth: "100%",
                    height: this.state.windowHeight / 6,
                    minHeight: "100%",
                    backgroundImage: `url(${project0})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "top center",
                    filter: `blur(2px)`,
                    // -webkit-filter: blur(8px);
                  }}
                />
                <Carousel.Caption style={{ top: 0, bottom: 0 }}>
                  <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                    <a href="/projects">
                      <h1 style={{ textAlign: 'center', color: 'white', textShadow: `1px 1px #000` }}><b>&lt;Projects&gt;</b></h1>
                    </a>
                  </div>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>

            <Carousel style={{ height: "100%", width: "100%" }} interval={null} indicators={true}>
              <Carousel.Item style={{ height: "100%", minHeight: "100px", width: "100%" }}>
                <div
                  className="d-block"
                  style={{
                    minWidth: "100%",
                    height: (this.state.windowWidth < 960) ? this.state.windowHeight / 2.5 : this.state.windowHeight / 1.5,
                    minHeight: "100%",
                    backgroundImage: `url(${project1})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                    // filter: `blur(5px)`,
                    // -webkit-filter: blur(8px);
                  }}
                />
                <Carousel.Caption style={{ top: 0, }}>
                  <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'flex-end' }}>
                    <a href="/projects#MezastarGuide">
                      <h1 style={{ textAlign: 'center', color: 'white', textShadow: `1px 1px #000` }}><b>MezastarGuide</b></h1>
                    </a>
                  </div>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item style={{ height: "100%", minHeight: "100px", width: "100%" }}>
                <div
                  className="d-block"
                  style={{
                    minWidth: "100%",
                    height: (this.state.windowWidth < 960) ? this.state.windowHeight / 2.5 : this.state.windowHeight / 1.5,
                    minHeight: "100%",
                    backgroundImage: `url(${project2})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                    // filter: `blur(5px)`,
                    // -webkit-filter: blur(8px);
                  }}
                />
                <Carousel.Caption style={{ top: 0, }}>
                  <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'flex-end' }}>
                    <a href="/projects#GaOleGuide">
                      <h1 style={{ textAlign: 'center', color: 'white', textShadow: `1px 1px #000` }}><b>GaOleGuide</b></h1>
                    </a>
                  </div>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <div
                  className="d-block"
                  style={{
                    minWidth: "100%",
                    height: (this.state.windowWidth < 960) ? this.state.windowHeight / 2.5 : this.state.windowHeight / 1.5,
                    minHeight: "100%",
                    backgroundImage: `url(${project3})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center center",
                  }}
                />
                <Carousel.Caption style={{ top: 0, }}>
                  <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'flex-end', }}>
                    <a href="/projects#Qlassroom">
                      <h1 style={{ textAlign: 'center', color: 'white', textShadow: `1px 1px #000` }}><b>Qlassroom</b></h1>
                    </a>
                  </div>
                </Carousel.Caption>
              </Carousel.Item>
              <Carousel.Item>
                <div
                  className="d-block"
                  style={{
                    minWidth: "100%",
                    height: (this.state.windowWidth < 960) ? this.state.windowHeight / 2.5 : this.state.windowHeight / 1.5,
                    minHeight: "100%",
                    backgroundImage: `url(${senior})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
                <Carousel.Caption style={{ top: 0, }}>
                  <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'flex-end', }}>
                    <a href="/projects#WRO">
                      <h1 style={{ textAlign: 'center', color: 'white', textShadow: `1px 1px #000` }}><b>WRO 2021 Senior Randomizer</b></h1>
                    </a>
                  </div>
                </Carousel.Caption>
              </Carousel.Item>
            </Carousel>
          </Grid>
        </Grid>

        {/* <Grid container style={{ marginTop: 32, marginBottom: 128, paddingLeft: 64, paddingRight: 64 }}>
          <Grid xs={12} style={{ display: 'flex', flexDirection: 'column' }}>
            <h2 style={{ textAlign: "left", marginBottom: 32, marginTop: 16 }}><b>&lt;Pokémon Team Reports&gt;</b></h2>
            <Grid container spacing={6}>
              <Grid xs={12} md={6} lg={4} item style={{ height: this.state.windowHeight / 2.5, marginBottom: 16 }}>
                <a href="/pokemon-asia-cup-2021">
                  <div class="reportbox" style={{
                    height: "60%", backgroundImage: `url(${asiathumb})`, display: 'flex', backgroundRepeat: "no-repeat", backgroundSize: "cover", backgroundPosition: "center", backdropFilter: `blur(5px)`,
                  }}>
                  </div>
                  <h2 style={{ textAlign: 'left', alignSelf: 'end' }}>Pokémon Asia Cup 2021:<br />Lilligant Shenanigans</h2>
                </a>
              </Grid>
            </Grid>
          </Grid>
        </Grid> */}
        <Grid container style={{ marginTop: 32, paddingBottom: 64 }}>
          <Grid size={{ xs: 12 }} style={{ display: 'flex', flexDirection: 'column', color: '#FFF' }}>
            <h2><b>&lt;Want to follow up?&gt;</b></h2>
            <a style={{ color: '#FFF' }} id="x" href="https://www.x.com/iamtehtarik" target="_blank" rel="noreferrer">X (Twitter)</a>
            <a style={{ color: '#FFF' }} id="youtube1" href="https://www.youtube.com/@iamtehtarik" target="_blank" rel="noreferrer">YouTube: TehTarik</a>
            <a style={{ color: '#FFF' }} id="youtube2" href="https://www.youtube.com/@thearcadearchival" target="_blank" rel="noreferrer">YouTube: The Arcade Archival</a>
            <a style={{ color: '#FFF' }} id="youtube2" href="https://www.github.com/tehdrink" target="_blank" rel="noreferrer">GitHub</a>
            <a style={{ color: '#FFF' }} id="coffee" href="https://ko-fi.com/tehdrink" target="_blank" rel="noreferrer">Buy me a coffee! ☕️</a>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(styles)(Home);
